import Image from 'next/image';
import { Typography } from '@/components';
import { RubyPlay } from '@/assets';

const AnnouncementBar = () => (
  <div className='w-full h-9 md:h-11 bg-[#102017] flex items-center justify-center gap-2'>
    <Typography tag='p' size='bodyExtraSmall' weight='bold' className='text-neutral-0 uppercase'>
      Part of
    </Typography>
    <Image src={RubyPlay} alt='RubyPlay' className='h-4 w-auto md:h-5' />
  </div>
);

export default AnnouncementBar;
